import angular from 'angular';
import insurerComparisonModal from './insurerComparisonModal';
import './style.scss';

export default angular
  .module('components.insurerComparisonModal', [])
  .component('insurerComparisonModal', insurerComparisonModal).name;
